import { RandomNthSelection } from '@/components/Contacts/CommonActions/RandomNth';
import { useSelectedEntity } from '@/components/Contacts/Group/hooks';
import { DEFAULT_PER_PAGE_COUNT } from '@/services/constants';
import { ContactsPaths } from '@/services/dictionaries/Paths';
import { DisableDialog, HideDialog, ShowDialog } from '@/store/dialog/actions';
import { ShowDialogParams } from '@/store/dialog/types';
import { getListstStore, ListCreateRandomStart, ListCreateNthStart } from '@/store/lists/actions';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'redux-first-history';

export const useAddRandomNthList = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { selectedEntity } = useSelectedEntity();
    const lists = useSelector(getListstStore);

    const addRandomNthList = (single: boolean): void => {
        let newList = { ...lists.newList };
        const prepareParams = (list): void => {
            newList = { ...newList, ...list };
        };

        const params: ShowDialogParams = {
            title: single ? t('createrandomlist') : t('createnthselectionlists'),
            confirmLabel: t('save'),
            isHiddenManually: !single,

            onClickConfirm: (): void => {
                const listCount = lists?.listNamesCollection?.length || lists?.totalCount || 0;
                if (single) {
                    dispatch(ListCreateRandomStart(newList));
                    return;
                }

                dispatch(ListCreateNthStart(newList));
                dispatch(DisableDialog(true));

                const checkIfNthSelectionAreCreated = setInterval(() => {
                    if (lists?.isNthListCreated) {
                        return;
                    }
                    dispatch(HideDialog());

                    dispatch(
                        push(
                            `${ContactsPaths.Lists}?page=${
                                Math.floor((listCount + 1) / DEFAULT_PER_PAGE_COUNT) + 1
                            }&perPage=${DEFAULT_PER_PAGE_COUNT}`
                        )
                    );
                    clearInterval(checkIfNthSelectionAreCreated);
                }, 1000);
            },
            cancelLabel: t('cancel'),
            body: (
                <RandomNthSelection
                    singlelist={single}
                    selected={selectedEntity}
                    newList={newList}
                    onPrepareParams={prepareParams}
                />
            ),
            isDisabled: true,
        };

        dispatch(ShowDialog(params));
    };

    return { addRandomNthList };
};
